export class UrlHelper {
    static getUrlParameter(name: string, url: string): string | null {
      name = name.replace(/[\[\]]/g, '\\$&');
      const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      const results = regex.exec(url);
      return results ? decodeURIComponent(results[2].replace(/\+/g, ' ')) : null;
    }
  
    static getPathFromUrl(url: string): string | undefined {
      return url.split('com.nhaschools.app:/').pop();
    }
  }
  